import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithPwPrefix } from 'store/middleware/pwContextMiddleware';

import { WIDGET_API, WIDGET_API_V2 } from '../../utils';
import { transformWithdrawalRejectRequestResponse } from '../formatters/withdrawalReject';
import type {
  PayHubCashierContractsReversePendingWithdrawalV2Request,
  PayHubCashierContractsReversePendingWithdrawalV2Response,
  WithdrawalRejectRequestResponse,
} from '../models';

const baseQueryV2 = createBaseQueryWithPwPrefix(WIDGET_API_V2);

export const withdrawalRejectAPI = createApi({
  reducerPath: 'withdrawalRejectAPI',
  baseQuery: createBaseQueryWithPwPrefix(WIDGET_API),
  endpoints(builder) {
    return {
      withdrawalRejectRequest: builder.query<WithdrawalRejectRequestResponse, void>({
        query: () => 'payments/reverse-pending-withdrawal',
        transformResponse: (response: WithdrawalRejectRequestResponse) =>
          transformWithdrawalRejectRequestResponse(response) as unknown as WithdrawalRejectRequestResponse,
      }),
      reversePendingWithdrawalV2: builder.mutation<
        PayHubCashierContractsReversePendingWithdrawalV2Response,
        PayHubCashierContractsReversePendingWithdrawalV2Request
      >({
        queryFn: async (body, api, extraOptions) => {
          const result = await baseQueryV2(
            { url: 'payments/reverse-pending-withdrawal', method: 'POST', body },
            api,
            extraOptions,
          );

          return result.error
            ? { error: result.error }
            : { data: result.data as PayHubCashierContractsReversePendingWithdrawalV2Response };
        },
      }),
    };
  },
});

export const { useLazyWithdrawalRejectRequestQuery, useReversePendingWithdrawalV2Mutation } = withdrawalRejectAPI;
export default withdrawalRejectAPI.reducer;
